import Button from "./Button"

const Form = ( {handleNewDrink, drinkName, ingredients, process, creator }) => {
    return (
        <>
        <form className="grid" action="">
            <label htmlFor="dname">Drink Name: </label>
            <input className='border-2 border-black rounded text-sky-500' type="text" id="dname" ref={drinkName}/> <br />
            <label htmlFor="ingredients">Ingredients: </label>
            <input className='border-2 border-black rounded text-sky-500' type="text" id="ingredients" ref={ingredients}/> <br />
            <label htmlFor="todo">How to do it? </label>
            <textarea className='border-2 border-black rounded text-sky-500' type="text" id="todo" ref={process}></textarea> <br />
            <label htmlFor="bywho">Created by: </label>
            <input className='border-2 border-black rounded text-sky-500' type="text" id="bywho" ref={creator} /> <br />
            <Button btnName={'Save'} onClick={handleNewDrink}/>
        </form>
        </>
    )
}

export default Form